import makeStyles from "@mui/styles/makeStyles";

const Style = makeStyles((theme) => ({
  root: {
    height: "80vh",
  },
  content: {
    padding: theme.spacing(0, 3),
    textAlign: "center",

    "& h5": {
      fontSize: 18,
    },
  },
  spinBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
}));

export default Style;
